.list {
  background-color: var(--common-white);
}

.content {
  flex-direction: column;
}

.typeName {
  font-weight: 500;
}

.details {
  flex-direction: column;
  padding: 0;
}
